import type { RadialDatum } from "@outpave/ds";

/** The category unmatched expenses fall back to, by its stored name. */
export const UNCATEGORIZED_CATEGORY = "Uncategorized";

const isUnnamed = (entry: RadialDatum) => !entry.label?.trim();

/**
 * Spend whose category has no name is spend with no category at all, so it is
 * counted with Uncategorized rather than drawn as a ring with an empty label.
 */
export const foldUnnamedCategories = (
  entries: RadialDatum[],
): RadialDatum[] => {
  if (!entries.some(isUnnamed)) return entries;

  const unnamedTotal = entries
    .filter(isUnnamed)
    .reduce((sum, entry) => sum + entry.value, 0);
  const named = entries.filter((entry) => !isUnnamed(entry));
  const uncategorized = named.find(
    (entry) => entry.label === UNCATEGORIZED_CATEGORY,
  );
  if (uncategorized) {
    return named.map((entry) =>
      entry === uncategorized
        ? { ...entry, value: entry.value + unnamedTotal }
        : entry,
    );
  }
  return [
    ...named,
    {
      id: UNCATEGORIZED_CATEGORY,
      label: UNCATEGORIZED_CATEGORY,
      value: unnamedTotal,
    },
  ];
};
